import { InjectionToken } from '@angular/core';
import { LogLevel } from './log-levels';
import { LoggerProvider } from './services/logger-provider.service';

export interface ModuleLogLevel {
  [moduleName: string]: LogLevel;
}

export interface LoggerOptions {
  minLogLevel?: LogLevel | string;
  moduleLogLevels?: { [moduleName: string]: LogLevel };
  dateFormat?: string;
  logFormat?: string;
  collapsed?: boolean;
  enableTrace?: boolean;
  traceCollapsed?: boolean;
  tableCollapsed?: boolean;
}

export const LOGGER_OPTIONS = new InjectionToken<LoggerOptions>('Logger options');
export const MIN_LOG_LEVEL = new InjectionToken<LogLevel>('Minimum log level');
export const LOGGER_PROVIDERS = new InjectionToken<LoggerProvider[]>('Providers for the logger');

export const defaultLoggerOptions: LoggerOptions = {
  minLogLevel: LogLevel.NEVER,
  moduleLogLevels: {},
  dateFormat: 'dd.MM.yyyy HH:mm:ss',
  logFormat: '[{date}] [{module}] {message}',
  collapsed: true,
  enableTrace: false,
  traceCollapsed: true,
  tableCollapsed: true,
};
